import { GenericAutocomplete } from "../../../GenericAutocomplete";
import { MenuItem, MenuItems } from "../../types";
import { getLeafNodes } from "../../helpers/getLeafNodes";
import styles from "./styles.module.css";

interface Props {
  menuItems: MenuItems;
  menuItem: MenuItem | null;
  onSelectItem: (item: MenuItem | null) => void;
  className?: string;
}

export const SidebarItemsAutocomplete = ({
  menuItems,
  menuItem,
  onSelectItem,
  className,
}: Props) => {
  return (
    <GenericAutocomplete<MenuItem>
      options={getLeafNodes(menuItems)}
      value={menuItem}
      onChange={onSelectItem}
      getLabel={(item) => item.name}
      getValue={(item) => item.id}
      getOptionKey={(item) => item.id}
      autocompleteStyle={"select"}
    />
  );
};
